import React from 'react';
import { Tooltip, Typography } from '../../index';

export const NavigationHead = ({
    className,
    disabled,
    label,
    selected,
    tooltip
}) => {

    const textColor = disabled
        ? selected ? '$color-secondary-a3' : '$color-secondary-a4'
        : selected ? '$color-primary-a3' : '$color-primary-a2';

    const navHeaderClasses = [
        `bsw-navigation__header align-items-center`,
        `${className ? className : ''}`
    ].join(' ');

    const navHeadContent = (
        <div data-container="MenuHeadItem" className={navHeaderClasses}>
            <Typography
                type="body-02"
                bold={selected}
                color={textColor}
            >
                {label}
            </Typography>
        </div>);
    
    return (tooltip && tooltip.text && (tooltip.open === undefined || tooltip.open === true)
        ? <Tooltip
            text={tooltip.text}
            tooltipId={tooltip.id || ''}
            linkText={tooltip.linkText || ''}
            linkOnClick={tooltip.linkOnClick || undefined}
            open={tooltip.open || undefined}
            placement={tooltip.placement || undefined}
            variant={tooltip.variant || undefined}
        >
            {navHeadContent}
        </Tooltip>
        : navHeadContent
    );

}
